export default [
    {
        name: 'rut',
        type: 'rut-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Rut',
        },
    },
    {
        name: 'business_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Razón social',
        },
    },
    {
        name: 'alias_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Alias',
        },
    },
    {
        name: 'is_pyme',
        type: 'switch',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: '¿Es PYME?',
        },
    },
]
